module.exports = __webpack_public_path__ + "static/img/1_1_5.9212191f.jpg";